import { Col, Icon, Row, Tabs, Switch, message, Modal } from 'antd';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Header from './../../../components/header';
import SideBar from './../../../components/sidebar-setting';
import { setHeight, titleHead } from './../../../services/helper';
import MFASetup from './../../../components/MFA/MFASetup';
import { onLoadAccount } from './../../../actions/settingAcountAction';
import handleException from './../../../services/handleException';
import { getAccount } from './../../../utils/settingAccount';
import { disableMFA } from './../../../utils/mfa';
import './styles.css';

class SettingMFA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mfaEnabled: false,
            showSetupModal: false
        };
    }

    componentDidMount() {
        titleHead('Two-Factor Authentication');
        setHeight();
        window.addEventListener('resize', this.updateDimensions);

        getAccount().then(account => {
          this.props.onLoadAccount(account.data.data)

          this.setState({
            mfaEnabled: account.data.data.TwoFactorEnabled
        })
        }).catch(error => {
            handleException(error)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setHeight();
    }

    updateDimensions() {
        setHeight();
    }

    handleSwitchChange = (checked) => {
        if (checked) {
            this.setState({ mfaEnabled: true, showSetupModal: true });
        } else {
            Modal.confirm({
                title: 'Disable Two-Factor Authentication',
                content: 'Are you sure you want to disable two-factor authentication? This will reset your MFA setup and make your account less secure.',
                okText: 'Yes, disable it',
                okType: 'danger',
                cancelText: 'No, keep it enabled',
                onOk: () => {
                    disableMFA().then(() => {
                        this.setState({ mfaEnabled: false });
                        message.info('Two-Factor Authentication disabled');
                    }).catch(error => {
                        handleException(error);
                        this.setState({ mfaEnabled: true });
                    });
                }
            });
        }
    };

    handleSetupSuccess = () => {
        this.setState({ showSetupModal: false, mfaEnabled: true });
        message.success('Two-Factor Authentication enabled successfully');
        // Refresh account data to get updated MFA status
        getAccount().then(account => {
            this.props.onLoadAccount(account.data.data);
        }).catch(error => {
            handleException(error);
        });
    };

    handleSetupClose = () => {
        // If user closes modal without completing setup, turn switch off
        this.setState({ showSetupModal: false, mfaEnabled: false });
    };

    render() {
        return (
            <div id="setting-mfa">
                <Header />
                <Row className="content">
                    <Col id="setting-left" className="menu-col" span={3}>
                        <SideBar />
                    </Col>
                    <Col id="setting-right" span={21}>
                        <div className="title title-top">
                            <Icon type="safety" style={{ fontSize: '50px', color: '#989898' }} />
                            <span className="text-title">Two-Factor Authentication</span>
                        </div>
                        <div className="setting-right-content">
                            <div style={{ maxWidth: 500, margin: '0 auto' }}>
                                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', marginBottom: 24, border: '1px solid #d9d9d9', padding: '16px', borderRadius: '4px', width: 'fit-content', margin: '0 auto' }}>
                                    <span style={{ fontWeight: 500, fontSize: 18, marginRight: 16 }}>Enable Two-Factor Authentication</span>
                                    <Switch
                                        checked={this.state.mfaEnabled}
                                        onChange={this.handleSwitchChange}
                                    />
                                </div>
                                <MFASetup
                                    visible={this.state.showSetupModal}
                                    onClose={this.handleSetupClose}
                                    onSuccess={this.handleSetupSuccess}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(
    null,
    { onLoadAccount }
)(SettingMFA);



// WEBPACK FOOTER //
// ./src/containers/setting/mfa/index.js